import { useMemo } from "react";

import { IntlShape } from "react-intl";

import { EntityTypesSupportedByIntegrations } from "@mapmycustomers/shared/types/entity";

import { IntegrationFieldsMapping } from "@app/store/integrations";
import Integration from "@app/types/integrations/Integration";
import IntegrationUser from "@app/types/integrations/IntegrationUser";

import IntegrationEditStep from "../enum/IntegrationEditStep";

import getStep1ErrorMessage from "./getStep1ErrorMessage";
import getStep2ErrorMessage from "./getStep2ErrorMessage";

const useNextButtonState = (
  intl: IntlShape,
  currentStep: IntegrationEditStep,
  integrationUsers: IntegrationUser[],
  integrationFields: IntegrationFieldsMapping,
  syncedEntityTypes: EntityTypesSupportedByIntegrations[],
  currentIntegration?: Integration
): [boolean, string | undefined] =>
  useMemo(() => {
    let disabled: boolean = false;
    let disabledMessage: string | undefined;
    if (!currentIntegration) {
      disabled = true;
    } else if (currentStep === IntegrationEditStep.CHOOSE) {
      if (
        !Object.values(currentIntegration!.syncOptions).some(
          ({ incoming, outgoing }) => incoming || outgoing
        )
      ) {
        disabled = true;
      } else {
        disabledMessage = getStep1ErrorMessage(intl, integrationUsers);
        disabled = !!disabledMessage;
      }
    } else if (currentStep === IntegrationEditStep.MAP) {
      disabledMessage = getStep2ErrorMessage(
        intl,
        integrationFields,
        syncedEntityTypes,
        currentIntegration.type
      );
      disabled = !!disabledMessage;
    }
    return [disabled, disabledMessage];
  }, [
    currentIntegration,
    currentStep,
    integrationFields,
    integrationUsers,
    intl,
    syncedEntityTypes,
  ]);

export default useNextButtonState;
